module.exports = __webpack_public_path__ + "static/media/event.fd83a37a.png";